module.exports = __webpack_public_path__ + "img/ic-quality-check.74c9a9b1.svg";